import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, take } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@lp/services/auth';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter, map } from 'rxjs/operators';
import { InteractionStatus } from '@azure/msal-browser';
import { APP_ROUTES } from '@lp/routes';

export const rolesAvailableGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const broadcast = inject(MsalBroadcastService);
  const router = inject(Router);

  return broadcast.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    take(1),
    map(() => {
      const isLoggedIn = auth.loggedIn();
      const hasRoles = auth.roles && auth.roles.length > 0;

      if (isLoggedIn && !hasRoles) {
        return router.parseUrl(APP_ROUTES.error);
      }

      if (!isLoggedIn) {
        auth.login();
        return false;
      }
      return true;
    })
  );
};
